/**
 * Stub for pages not yet implemented (Map / Settings / Analytics).
 * Each one will get its own file when we wire up the corresponding API.
 */
export function PlaceholderPage({ title }: { title: string }) {
  return (
    <div className="rounded-lg border border-dashed border-slate-300 bg-white p-12 text-center">
      <h1 className="text-xl font-semibold text-slate-700">{title}</h1>
      <p className="mt-2 text-sm text-slate-500">
        Σύντομα. Phase 6 next-up.
      </p>
    </div>
  );
}
